import React, { useState, useEffect } from 'react';
// import { Modal, Button, Form, Spinner } from 'react-bootstrap';
import SummernoteEditor from './summernote';
import { Button, Form, Row, Col, Modal, Spinner } from "react-bootstrap";

const QuestionModal = ({ show, handleClose, qcm_ref, user_id, reussite }) => {
    // console.log('show :', show)
    // console.log('handleClose :', handleClose)
    console.log('qcm_ref :', qcm_ref)
    // console.log('user_id :', user_id)
    const [formData, setFormData] = useState({
        ref: '',
        questionFr: '',
        questionEn: '',
        optionAFr: '',
        optionBFr: '',
        optionCFr: '',
        optionDFr: '',
        optionEFr: '',
        optionFFr: '',
        optionAEn: '',
        optionBEn: '',
        optionCEn: '',
        optionDEn: '',
        optionEEn: '',
        optionFEn: '',
        reponseFr: '',
        reponseEn: '',
        explicationFr: '',
        explicationEn: ''
    });

    const [loading, setLoading] = useState(true);
    const [submitting, setSubmitting] = useState(false);

    const [alert, setAlert] = useState({ message: '', type: '' });
    const showAlert = (message, type = 'success') => {
        setAlert({ message, type });
        // setTimeout(() => {
        //     setAlert({ message: '', type: '' });
        // }, 7000);
    };

    const fermerNotif = () => {
        setAlert({ message: '', type: '' });
    }

    const closeWithDelay = () => {
        setTimeout(() => {
            handleClose();
        }, 200); // délai de 200ms
    };

    useEffect(() => {
        const fetchQCMData = async () => {
            try {
                setLoading(true);

                const resFr = await fetch(`${process.env.REACT_APP_HOTE}/qcm-fr-info/${encodeURIComponent(qcm_ref)}/`);
                if (!resFr.ok) {
                    throw new Error('Erreur lors de la récupération des données FR');
                }
                const dataFr = await resFr.json();

                let dataEn = {};
                try {
                    const resEn = await fetch(`${process.env.REACT_APP_HOTE}/qcm-en-info/${encodeURIComponent(qcm_ref)}/`);
                    if (resEn.ok) {
                        dataEn = await resEn.json();
                    } else {
                        console.warn('Aucune version EN trouvée');
                    }
                } catch (err) {
                    console.warn('Erreur chargement EN :', err);
                }

                setFormData({
                    ref: dataFr.ref || '',
                    questionFr: dataFr.question || '',
                    optionAFr: dataFr.option1 || '',
                    optionBFr: dataFr.option2 || '',
                    optionCFr: dataFr.option3 || '',
                    optionDFr: dataFr.option4 || '',
                    optionEFr: dataFr.option5 || '',
                    optionFFr: dataFr.option6 || '',
                    explicationFr: dataFr.explication || '',

                    questionEn: dataEn.question || '',
                    optionAEn: dataEn.option1 || '',
                    optionBEn: dataEn.option2 || '',
                    optionCEn: dataEn.option3 || '',
                    optionDEn: dataEn.option4 || '',
                    optionEEn: dataEn.option5 || '',
                    optionFEn: dataEn.option6 || '',
                    explicationEn: dataEn.explication || '',

                    reponseFr: dataFr.reponse || '',
                    reponseEn: dataEn.reponse || '',
                });

                // if (!dataEn?.question) {
                //     showAlert('⚠️ Aucune version anglaise trouvée pour ce QCM.', 'warning');
                // }

            } catch (error) {
                console.error("Erreur :", error);
                showAlert('Erreur lors du chargement des données', 'danger');
                handleClose();
            } finally {
                setLoading(false);
            }
        };

        if (show && qcm_ref) {
            fetchQCMData();
        }
    }, [show, qcm_ref]);


    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({ ...prev, [name]: value }));
    };

    const handleSubmit = async (event) => {
        event.preventDefault();
        setSubmitting(true);
        fermerNotif();

        const {
            ref,
            questionFr,
            optionAFr,
            optionBFr,
            optionCFr,
            optionDFr,
            optionEFr,
            optionFFr,
            reponseFr,
            explicationFr,

            questionEn,
            optionAEn,
            optionBEn,
            optionCEn,
            optionDEn,
            optionEEn,
            optionFEn,
            reponseEn,
            explicationEn,
        } = formData;

        const dataFr = {
            ref: ref,
            question: questionFr,
            optionAFr: optionAFr,
            optionBFr: optionBFr,
            optionCFr: optionCFr,
            optionDFr: optionDFr,
            optionEFr: optionEFr,
            optionFFr: optionFFr,
            reponse: reponseFr,
            explication: explicationFr,
        };

        const dataEn = {
            ref: ref,
            questionEn: questionEn,
            optionAEn: optionAEn,
            optionBEn: optionBEn,
            optionCEn: optionCEn,
            optionDEn: optionDEn,
            optionEEn: optionEEn,
            optionFEn: optionFEn,
            reponseEn: reponseEn,
            explicationEn: explicationEn,
        };

        try {
            const responseFr = await fetch(`${process.env.REACT_APP_HOTE}/modifier-qcm-fr/${qcm_ref}/${user_id}/`, {
                method: 'PUT',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(dataFr),
            });

            const frResult = await responseFr.json();

            if (!responseFr.ok) {
                showAlert(`Erreur FR: ${frResult?.error || 'Erreur inconnue.'}`, 'danger');
                return;
            }

            // Enregistrer EN seulement s’il y a du contenu
            if (questionEn?.trim()) {
                const responseEn = await fetch(`${process.env.REACT_APP_HOTE}/modifier-qcm-en/${qcm_ref}/${user_id}/`, {
                    method: 'PUT',
                    headers: {
                        'Content-Type': 'application/json',
                    },
                    body: JSON.stringify(dataEn),
                });

                const enResult = await responseEn.json();

                if (!responseEn.ok) {
                    showAlert(`⚠️ Erreur EN : ${enResult?.error || 'Erreur inconnue lors de la sauvegarde de la version anglaise.'}`, 'warning');
                    return;
                }
            }

            showAlert('✅ Modification effectuée avec succès', 'success');
            handleClose();
            reussite();

        } catch (error) {
            console.error('Erreur lors de la soumission :', error);
            showAlert('❌ Une erreur est survenue lors de la soumission.', 'danger');
        } finally {
            setSubmitting(false);
        }
    };


    return (
        <Modal show={show} onHide={handleClose} size="lg" centered>
            <Modal.Header>
                <Modal.Title>
                    {loading ? 'Chargement...' : 'Modifier question'}
                </Modal.Title>
            </Modal.Header>{alert.message && (
                <div className={`alert alert-${alert.type} row justify-content-between position-relative m-3`}>
                    <div
                        // Utilisation de dangerouslySetInnerHTML pour afficher le message HTML
                        dangerouslySetInnerHTML={{ __html: alert.message }}
                    />

                    <span
                        onClick={fermerNotif}
                        style={{
                            position: 'absolute',
                            top: '0px',   // Ajustez l'espacement comme vous le souhaitez
                            right: '10px', // Ajustez l'espacement comme vous le souhaitez
                            cursor: 'pointer'
                        }}
                    >
                        <i className='fa fa-close'></i>
                    </span>
                </div>
            )}
            <Modal.Body>
                {loading ? (
                    <div className="text-center py-4">
                        <Spinner animation="border" variant="primary" />
                        <p className="mt-2">Chargement des données...</p>
                    </div>
                ) : (
                    <Form onSubmit={handleSubmit}>
                        <Form.Group className="mb-3">
                            <Form.Label><b>Référence</b></Form.Label>
                            <Form.Control
                                type="text"
                                name="ref"
                                placeholder="Entrez la référence"
                                required
                                value={formData.ref}
                                onChange={handleChange}
                                disabled={submitting}
                            />
                        </Form.Group>

                        <Row>
                            <Col md={6}>
                                {/* <h5>Version Française</h5> */}
                                {/* Champs en français */}
                                <Form.Group className="mb-3">
                                    <Form.Label>Question (FR)</Form.Label>
                                    <SummernoteEditor
                                        value={formData.questionFr}
                                        onChange={(value) => setFormData(prev => ({ ...prev, questionFr: value }))}
                                        disabled={submitting}
                                    />
                                </Form.Group>

                                {['A', 'B', 'C', 'D', 'E', 'F'].map(letter => (
                                    <Form.Group className="mb-3" key={letter}>
                                        <Form.Label>Option {letter}</Form.Label>
                                        <Form.Control
                                            type="text"
                                            name={`option${letter}Fr`}
                                            value={formData[`option${letter}Fr`]}
                                            onChange={handleChange}
                                            disabled={submitting}
                                            placeholder={`Option ${letter} (FR)`}
                                        />
                                    </Form.Group>
                                ))}


                                <Form.Group className="mb-3">
                                    <Form.Label>Réponse</Form.Label>
                                    <Form.Control
                                        type="text"
                                        name="reponseFr"
                                        value={formData.reponseFr}
                                        onChange={handleChange}
                                        disabled={submitting}
                                    />
                                </Form.Group>

                                <Form.Group className="mb-3">
                                    <Form.Label>Explication (FR)</Form.Label>
                                    <SummernoteEditor
                                        value={formData.explicationFr}
                                        onChange={(value) => setFormData(prev => ({ ...prev, explicationFr: value }))}
                                        disabled={submitting}
                                    />
                                </Form.Group>
                            </Col>

                            <Col md={6}>
                                {/* <h5>Version Anglaise</h5> */}
                                {/* Champs en anglais */}
                                <Form.Group className="mb-3">
                                    <Form.Label>Question (EN)</Form.Label>
                                    <SummernoteEditor
                                        value={formData.questionEn}
                                        onChange={(value) => setFormData(prev => ({ ...prev, questionEn: value }))}
                                        disabled={submitting}
                                    />
                                </Form.Group>

                                {['A', 'B', 'C', 'D', 'E', 'F'].map(letter => (
                                    <Form.Group className="mb-3" key={letter}>
                                        <Form.Label>Option {letter}</Form.Label>
                                        <Form.Control
                                            type="text"
                                            name={`option${letter}En`}
                                            value={formData[`option${letter}En`]}
                                            onChange={handleChange}
                                            disabled={submitting}
                                            placeholder={`Option ${letter} (EN)`}
                                        />
                                    </Form.Group>
                                ))}


                                <Form.Group className="mb-3">
                                    <Form.Label>Réponse</Form.Label>
                                    <Form.Control
                                        type="text"
                                        name="reponseEn"
                                        value={formData.reponseEn}
                                        onChange={handleChange}
                                        disabled={submitting}
                                    />
                                </Form.Group>

                                <Form.Group className="mb-3">
                                    <Form.Label>Explication (EN)</Form.Label>
                                    <SummernoteEditor
                                        value={formData.explicationEn}
                                        onChange={(value) => setFormData(prev => ({ ...prev, explicationEn: value }))}
                                        disabled={submitting}
                                    />
                                </Form.Group>
                            </Col>
                        </Row>


                        <div className="d-flex justify-content-end gap-2">
                            <Button className='mr-2' variant="secondary" onClick={closeWithDelay} disabled={submitting}>
                                Annuler
                            </Button>
                            <Button variant="primary" type="submit" disabled={submitting}>
                                {submitting ? (
                                    <>
                                        <Spinner as="span" animation="border" size="sm" role="status" aria-hidden="true" />
                                        <span className="ms-2">Enregistrement...</span>
                                    </>
                                ) : 'Enregistrer'}
                            </Button>
                        </div>
                    </Form>
                )}
            </Modal.Body>
        </Modal>
    );
};

export default QuestionModal;